import { render, staticRenderFns } from "./ProductMonitorDetail.vue?vue&type=template&id=599d3d67&scoped=true&"
import script from "./ProductMonitorDetail.vue?vue&type=script&lang=js&"
export * from "./ProductMonitorDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProductMonitorDetail.vue?vue&type=style&index=0&id=599d3d67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "599d3d67",
  null
  
)

export default component.exports